import PropTypes from 'prop-types';

import useMartyContext from 'hooks/useMartyContext';
import { openPopup } from 'helpers';
import { UPS_FIND_STORE_URL } from 'constants/appConstants';

import css from 'styles/containers/returns/doneSection.scss';

const DoneSection = ({ postReturnInfo, boxInfo, isLabelless = false, isButtonOnly = false }) => {
  const {
    marketplace: {
      account: { returnLabelUrl }
    }
  } = useMartyContext();
  const singleBox = Object.keys(boxInfo).length === 1;

  /*
   * Because there currently isn't a way to associate which return label goes with which box based on
   * the data we get back from the submitReturn endpoint, we have to make the association ourselves on the client.
   */
  const makeReturnLabels = () => {
    const returnLabels = [];
    for (const box in boxInfo) {
      // select item from each individual box (doesn't matter which so let's use the first) and get its unitId
      const unitIdInBox = boxInfo[box].items[0].unitId;
      const matchingItem = postReturnInfo.find(indvReturn => {
        // find item within postReturnInfo object that has matching unitId
        const { returnItems } = indvReturn;
        return returnItems.find(item => {
          const { unitId } = item;
          return unitId === unitIdInBox;
        });
      });
      // we can then associate the postReturnInfo item's contractId/rmaId with that specific box and display box-associated returnLabel
      if (matchingItem) {
        const { rmaId, contractId } = matchingItem;
        const printLabelButton = (
          <a
            href={`${returnLabelUrl}?contractId=${contractId}&displayInfo=true`}
            className={css.action}
            data-popup-options="width=1000,height=800"
            onClick={openPopup}
          >
            {isLabelless ? 'Show Return Code' : singleBox ? 'Print Return Label' : `Print Label for Box ${box}`}
          </a>
        );

        // here return the print label button only
        if (isButtonOnly) {
          return printLabelButton;
        }

        returnLabels.push(
          <div className={css.returnLabel} key={rmaId}>
            <p>{rmaId}</p>
            {printLabelButton}
            {isLabelless && (
              <a className={css.action} href={UPS_FIND_STORE_URL}>
                Find the Closest UPS Store
              </a>
            )}
          </div>
        );
      }
    }
    return <div className={css.returnLabels}>{returnLabels}</div>;
  };

  return isButtonOnly ? (
    <section className={css.buttonOnly}>{makeReturnLabels()}</section>
  ) : (
    <section className={css.container}>
      <h1>Your return is confirmed</h1>
      <div className={css.confirmation}>
        {<h2>Return Confirmation Numbers</h2>}
        {makeReturnLabels()}
      </div>
    </section>
  );
};

DoneSection.propTypes = {
  postReturnInfo: PropTypes.array.isRequired
};

export default DoneSection;
